import { jsxs as t, jsx as o } from "react/jsx-runtime";
const e = ({ className: r }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M1.66683 6.66667C1.66683 6.66667 5.39779 2.5 10.0002 2.5C14.6025 2.5 18.3335 6.66667 18.3335 6.66667",
          stroke: "currentColor",
          strokeLinecap: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M17.9531 10.8709C18.2065 11.2261 18.3332 11.4038 18.3332 11.6667C18.3332 11.9297 18.2065 12.1073 17.9531 12.4626C16.8148 14.0588 13.9075 17.5 9.99984 17.5C6.09215 17.5 3.18492 14.0588 2.04654 12.4626C1.79318 12.1073 1.6665 11.9297 1.6665 11.6667C1.6665 11.4038 1.79318 11.2261 2.04654 10.8709C3.18492 9.27458 6.09215 5.83337 9.99984 5.83337C13.9075 5.83337 16.8148 9.27457 17.9531 10.8709Z",
          stroke: "currentColor"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M12.5 11.6666C12.5 10.2859 11.3807 9.16663 10 9.16663C8.61929 9.16663 7.5 10.2859 7.5 11.6666C7.5 13.0473 8.61929 14.1666 10 14.1666C11.3807 14.1666 12.5 13.0473 12.5 11.6666Z",
          stroke: "currentColor"
        }
      )
    ]
  }
);
export {
  e as ViewFileIcon
};
